import type { SendMethod } from "../../common/service/server/Types";

export interface DomainEmailSetupVisibilityInput {
  sendMethod?: SendMethod;
  hasOwnedPostmarkMailbox: boolean;
  isSharedPostmark: boolean;
  hasShareOptions: boolean;
}

export interface DomainEmailSetupVisibility {
  hasParentEmailSetupOptions: boolean;
  hasAvailableShareOptions: boolean;
  isPostmark: boolean;
  isNylas: boolean;
  usesOwnedPostmarkMailbox: boolean;
  canShowSetupDetails: boolean;
}

export function getDomainEmailSetupVisibility({
  sendMethod,
  hasOwnedPostmarkMailbox,
  isSharedPostmark,
  hasShareOptions,
}: DomainEmailSetupVisibilityInput): DomainEmailSetupVisibility {
  const hasParentEmailSetupOptions = isSharedPostmark || hasShareOptions;
  const hasAvailableShareOptions = !isSharedPostmark && hasShareOptions;
  const isPostmark = sendMethod === "POSTMARK" || isSharedPostmark || hasAvailableShareOptions;
  const usesOwnedPostmarkMailbox =
    sendMethod === "POSTMARK" &&
    !isSharedPostmark &&
    (hasOwnedPostmarkMailbox || !hasAvailableShareOptions);

  return {
    hasParentEmailSetupOptions,
    hasAvailableShareOptions,
    isPostmark,
    isNylas: !isPostmark,
    usesOwnedPostmarkMailbox,
    canShowSetupDetails:
      !isPostmark || isSharedPostmark || (usesOwnedPostmarkMailbox && hasOwnedPostmarkMailbox),
  };
}
